module.exports = require("@angular/cdk/observers");